import { deepmoxConfig } from "../../config/deepmoxConfig";

export const prototypeRuntimeConfig = deepmoxConfig.clientPrototype;
